import { trigger, transition, style, animate, query, stagger} from '@angular/animations';

export const listAnimation = trigger(
  'listAnimation', [
    transition('* => *', [
      query(':enter', [
        style({
          opacity: 0
        }),
        stagger(200, [
          animate('200ms ease-in-out', style({
            opacity: 1
          }))
        ])
      ])
    ])
  ]
);




// WEBPACK FOOTER //
// ./src/animations/list-animation.ts